module.exports = __webpack_public_path__ + "static/media/6i_website_logo_Platinum_recg.ee501ac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6i_website_logo_Platinum_recg.jpg
// module id = 104
// module chunks = 0